import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import { Link, useHistory, useLocation } from "react-router-dom";
import PageHeader from "../../../Components/PageHeader";
import LeftControl from "../../../Components/LeftControl";
import Services from '../../../Services';
import { paths } from "./path";
import SidebarApplicants from "../../../Components/SidebarApplicants";

const {
    Storage
} = Services;

const Submission = (props) => {


    const location = useLocation();
    const history = useHistory()
    const storage = new Storage();

     

    useEffect(() => {
         
        let user = JSON.parse(localStorage.getItem('user_profile'));
        if (user) {
            var { ApplicantStatusId } = user;
            if (props.status !== ApplicantStatusId) {
                history.push(paths[ApplicantStatusId])
            }
        }
    }, [])

    return (
        <Grid container xs={12} className="Liq-Container HRPortal">
            <Grid xs={12} md={2} className="LeftContol" id="LeftContol">
                <SidebarApplicants />
            </Grid>
            <Grid xs={12} md={10} container justify="center" className="PageContent">
                <Grid className="PagesFrame">
                    <PageHeader />
                    <Grid id="PageTitle">Waiting For HR Approval</Grid>
                    <div className="submission_inner">
                        <div className="SubmissionTable"><div></div></div>
                        <div className="main_cont">
                            <>Thank you for applying to TGS, Our HR Team will review your profile submission & get back to you.</>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default Submission;
